import {
  AiAgent,
  AiDocumentContentType,
  ContextDocument,
  FileUploadCategoryConfig,
  FileUploadConfig,
} from '../../../types/ai.types'
import { ContextDocumentContent, ContextDocumentResponse } from '../api/documents.api'

export const typeToAgentMap: Record<AiDocumentContentType, AiAgent> = {
  business_process: AiAgent.ANALYST,
  screen_name: AiAgent.DESIGNER,
  business_rule: AiAgent.DEVELOPER,
  compliance_check: null,
}

function extractContentFromDocumentResponse(content: ContextDocumentContent[]): {
  [key in AiAgent]?: ContextDocumentContent[]
} {
  return content.reduce(
    (acc, item) =>
      typeToAgentMap[item.type]
        ? { ...acc, [typeToAgentMap[item.type]]: [...acc[typeToAgentMap[item.type]], item] }
        : acc,
    { [AiAgent.ANALYST]: [], [AiAgent.DESIGNER]: [], [AiAgent.DEVELOPER]: [] }
  )
}

export class AiDocumentsTransformService {
  static configResponseTransform(config: FileUploadConfig): FileUploadConfig {
    const mergeFileUploadConfigs = (
      configs: FileUploadCategoryConfig[]
    ): FileUploadCategoryConfig =>
      configs.reduce(
        (acc, config) => ({
          fileType: [...acc.fileType, ...config.fileType],
          maxFileSize: Math.min(acc.maxFileSize, config.maxFileSize),
          maxFileNumber: Math.min(acc.maxFileNumber, config.maxFileNumber),
        }),
        {
          fileType: [],
          maxFileSize: Infinity,
          maxFileNumber: Infinity,
        }
      )

    return {
      ...config,
      fileUpload: {
        [AiAgent.ANALYST]: mergeFileUploadConfigs([config.imageUpload, config.bpmnUpload]),
        [AiAgent.DEVELOPER]: {
          fileType: [],
          maxFileSize: 0,
          maxFileNumber: 0,
        },
        [AiAgent.DESIGNER]: config.imageUpload,
        default: mergeFileUploadConfigs([config.imageUpload, config.documentUpload]),
      },
    }
  }

  static contextDocumentResponseTransform(response: ContextDocumentResponse[]): ContextDocument[] {
    return response.map((document) => ({
      id: document.id,
      type: document.file_properties.file_type,
      name: document.file_name,
      documentId: document.db_collection,
      summary: document.details.summary,
      ...extractContentFromDocumentResponse(document.details.content),
    }))
  }

}
